import { z } from 'zod';
import { getRangeAnalyticsWithIntervalQuerySchema } from './common';
export const getClaimedQuestsQuerySchema = z
    .object({
    status: z.enum(['success', 'fail', 'pending', 'all']),
})
    .merge(getRangeAnalyticsWithIntervalQuerySchema);
